import { atom, useAtom } from 'jotai';
export var selectedChannelAtom = atom('');
export var useChannelSelection = function useChannelSelection() {
  return useAtom(selectedChannelAtom);
};